import { render, staticRenderFns } from "./AvisoDaTelaClassica.vue?vue&type=template&id=5d6b7962&scoped=true&"
import script from "./AvisoDaTelaClassica.vue?vue&type=script&lang=ts&"
export * from "./AvisoDaTelaClassica.vue?vue&type=script&lang=ts&"
import style0 from "./AvisoDaTelaClassica.vue?vue&type=style&index=0&id=5d6b7962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b7962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
